export default "__VITE_ASSET__6b59b272__"